import axiosInstance from '../../../../../utils/axios';
import { RfxTradingAccountsResponse } from './models';
import { RfxTradingAccountsError } from './errors';

const getRfxTradingAccounts = async (token: string): Promise<RfxTradingAccountsResponse> => {
  try {
    const response = await axiosInstance.get<RfxTradingAccountsResponse>(
      '/rfx-withdrawal/trading-accounts',
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      },
    );
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new RfxTradingAccountsError(error.response.data?.status || 'UNKNOWN_ERROR');
    }
    throw new RfxTradingAccountsError('UNKNOWN_ERROR');
  }
};

export default getRfxTradingAccounts;
